module.exports = __webpack_public_path__ + "img/easy_wrong_topic_active.fdc06647.svg";